import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthInitializerService } from '../auth/auth-initializer.service';
import { isPublicAuthRoute } from '../auth/auth-cleanup';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  constructor(private authInitializer: AuthInitializerService) {}


  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Skip intercepting certain requests
    if (
      // Skip non-API requests
      (!request.url.includes('/api/') && !request.url.includes('/ai/') && !request.url.includes('/graphql')) ||
      // Skip pre-login SSO connection lookup (#10719) — must run before any JWT exists
      request.url.includes('/api/auth/sso-lookup') ||
      // Skip requests for public routes
      isPublicAuthRoute()
    ) {
      return next.handle(request);
    }

    // Use the AuthInitializerService to get a token
    return from(this.authInitializer.getToken()).pipe(
      switchMap(token => {
        if (token) {
          const authReq = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });
          return next.handle(authReq);
        } else {
          return next.handle(request);
        }
      }),
      catchError(error => {
        console.error('Auth token interceptor error:', error);
        // Don't send request without auth - return the error instead
        return throwError(() => error);
      })
    );
  }
}
